import type { CasesTableFilter } from "@/components/Table/MrtCaseTable.tsx";
import { useFetchCaseStatuses } from "@/queries/useFetchCaseStatuses.ts";
import { CircularProgress, MenuItem, Paper, Typography } from "@mui/material";
import { RhfTextField } from "mui-rhf-integration";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<CasesTableFilter>;
};

const CaseStatusesForCasesTable = ({ form }: Props) => {
    const { data, isError, isRefetching, isLoading } = useFetchCaseStatuses();

    if (isError) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <Typography variant={"h5"}>Error loading case statuses for cases table</Typography>
            </Paper>
        );
    }

    if (isLoading || isRefetching) {
        return (
            <Paper
                sx={{
                    p: 2,
                    borderRadius: "8px",
                }}
            >
                <CircularProgress size={"12px"} />
            </Paper>
        );
    }

    return (
        <RhfTextField
            select
            control={form.control}
            name={"caseStatus"}
            label={"Case Status"}
            sx={{
                width: "100%",
                backgroundColor: "#fff",
            }}
        >
            <MenuItem component={"li"} key={"case-status-blank"} value={""}>
                All
            </MenuItem>
            {data?.data.map((caseStatus) => (
                <MenuItem
                    component={"li"}
                    key={`caseStatus-${caseStatus.idUUID}`}
                    value={caseStatus.name ?? ""}
                >
                    {caseStatus.name ?? ""}
                </MenuItem>
            ))}
        </RhfTextField>
    );
};

export default CaseStatusesForCasesTable;
